import axiosClient, { unwrap } from "./axiosClient";
import { ENDPOINTS } from "./endpoints";

export const restaurantStockApi = {
  getAll: () =>
    axiosClient.get(ENDPOINTS.restaurantStock.list).then(unwrap),

  getById: (batchId) =>
    axiosClient.get(ENDPOINTS.restaurantStock.detail(batchId)).then(unwrap),

  create: (data) =>
    axiosClient.post(ENDPOINTS.restaurantStock.create, data).then(unwrap),

  bulkCreate: (data) =>
    axiosClient.post(ENDPOINTS.restaurantStock.bulkCreate, data).then(unwrap),

  update: (batchId, data) =>
    axiosClient.put(ENDPOINTS.restaurantStock.update(batchId), data).then(unwrap),

  remove: (batchId) =>
    axiosClient.delete(ENDPOINTS.restaurantStock.delete(batchId)).then(unwrap),

  lowStock: () =>
    axiosClient.get(ENDPOINTS.restaurantStock.lowStock).then(unwrap),
};